/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Drawer_TitleInputs */



/**
* | output |
* | --- |
* | "Audit Log Details" |
*
* @param {Audit_Details_Drawer_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_drawer_title = /** @type {((inputs?: Audit_Details_Drawer_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Drawer_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Log Details")
	return /** @type {LocalizedString} */ ("Audit Log Details")
});